/* aggiunge i parametri di autoplay muto all'URL di embed (YouTube/Vimeo) */
function autoplaySrc(src){
  if(!src) return src;
  var sep = src.indexOf('?') < 0 ? '?' : '&';
  var p = 'autoplay=1&mute=1&muted=1&loop=1&playsinline=1&controls=0&rel=0';
  var m = /youtube\.com\/embed\/([^?&#]+)/.exec(src);
  if(m) p += '&playlist=' + m[1];   // YouTube: il loop richiede la playlist
  return src + sep + p;
}
/* Galleria media prodotto nel riepilogo (desktop).
   Sorgente: window.WOW_PRODUCT_MEDIA = [{type:'image'|'video'|'external_video', src, poster, alt}, ...]
   - vista "photo": media del prodotto (default, sostituisce il placeholder del riepilogo)
   - vista "preview": anteprima live dello sticker (attiva da sola quando l'utente carica un file) */
(function(){
  var vis = document.getElementById('sum-vis');
  var img = document.getElementById('sumGalImg');
  if(!vis || !img) return;

  var media = (window.WOW_PRODUCT_MEDIA || []).filter(function(m){ return m && m.src; });
  if(!media.length){ vis.setAttribute('data-view','preview'); return; }

  var idx = 0, playerBox = null;

  function clearPlayer(){
    if(!playerBox) return;
    var v = playerBox.querySelector('video');
    if(v){ try{ v.pause(); }catch(e){} }
    playerBox.remove(); playerBox = null;
  }
  function makePlayer(m){
    var box = document.createElement('div');
    box.className = 'sum-gal-player';
    if(m.type === 'external_video'){
      var f = document.createElement('iframe');
      f.src = autoplaySrc(m.src); f.title = m.alt || 'Video prodotto'; f.loading = 'lazy';
      f.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      f.setAttribute('allowfullscreen','');
      box.appendChild(f);
    } else {
      var v = document.createElement('video');
      v.src = m.src; v.controls = true; v.playsInline = true; v.preload = 'auto';
      // autoplay: serve muto, altrimenti i browser lo bloccano
      v.muted = true; v.autoplay = true; v.loop = true;
      if(m.poster) v.poster = m.poster;
      box.appendChild(v);
      v.play().catch(function(){});
    }
    return box;
  }

  function show(i){
    idx = (i + media.length) % media.length;
    var m = media[idx];
    clearPlayer();
    var isVideo = m.type === 'video' || m.type === 'external_video';
    if(isVideo){
      playerBox = makePlayer(m);
      vis.appendChild(playerBox);
      img.removeAttribute('src'); img.alt = '';
    } else {
      img.src = m.src; img.alt = m.alt || '';
    }
    vis.classList.toggle('is-video', isVideo);
    vis.setAttribute('data-view','photo');
  }
  function showPreview(){ clearPlayer(); vis.classList.remove('is-video'); vis.setAttribute('data-view','preview'); }

  if(media.length > 1){
    [['prev','chevron_left',-1],['next','chevron_right',1]].forEach(function(cfg){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sum-gal-nav ' + cfg[0];
      b.setAttribute('aria-label', cfg[0] === 'prev' ? 'Media precedente' : 'Media successivo');
      b.innerHTML = '<span class="msr">' + cfg[1] + '</span>';
      b.addEventListener('click', function(e){ e.stopPropagation(); show(idx + cfg[2]); });
      vis.appendChild(b);
    });
  }

  show(0);

  /* la galleria prodotto resta sempre visibile: l'anteprima del file caricato
     è già mostrata nel configuratore, qui non serve sostituirla */
  new MutationObserver(function(){
    if(vis.getAttribute('data-view') !== 'photo') vis.setAttribute('data-view','photo');
  }).observe(vis, { attributes:true, attributeFilter:['class','data-view'] });
  void showPreview;
})();

/* ===== MOBILE: hero prodotto come carosello di tutti i media ===== */
(function(){
  var track = document.getElementById('pdHeroTrack');
  var dots  = document.getElementById('pdHeroDots');
  if(!track) return;
  var media = (window.WOW_PRODUCT_MEDIA || []).filter(function(m){ return m && m.src; });
  if(media.length < 2) return;

  var first = document.getElementById('pdHeroImg');
  track.innerHTML = '';

  media.forEach(function(m, i){
    var el;
    if(m.type === 'external_video'){
      el = document.createElement('iframe');
      el.src = autoplaySrc(m.src); el.loading = 'lazy'; el.title = m.alt || 'Video prodotto';
      el.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      el.setAttribute('allowfullscreen','');
    } else if(m.type === 'video'){
      el = document.createElement('video');
      el.src = m.src; el.controls = true; el.playsInline = true; el.preload = 'metadata';
      if(m.poster) el.poster = m.poster;
    } else if(i === 0 && first){
      el = first;
    } else {
      el = document.createElement('img');
      el.src = m.src; el.alt = m.alt || ''; el.loading = i ? 'lazy' : 'eager';
    }
    el.classList.add('pd-hero-slide');
    el.setAttribute('data-media', m.type || 'image');
    track.appendChild(el);
  });

  if(dots){
    dots.classList.add('on');
    media.forEach(function(){ dots.appendChild(document.createElement('i')); });
    var items = dots.querySelectorAll('i');
    items[0].classList.add('sel');
    var t;
    track.addEventListener('scroll', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        items.forEach(function(d, k){ d.classList.toggle('sel', k === i); });
        /* metti in pausa i video fuori vista */
        Array.prototype.forEach.call(track.children, function(el, k){
          if(k !== i && el.tagName === 'VIDEO'){ try{ el.pause(); }catch(e){} }
        });
      }, 90);
    }, { passive:true });
  }
})();
